import { initScrollableTableWithinRichText } from '../../../src/js/utilities/tables';
var initRichText = function initRichText(block) {
  initScrollableTableWithinRichText(block);
};
Array.from(document.querySelectorAll('.c-rich-text')).forEach(function (richText) {
  return initRichText(richText);
});